import React from "react";
import EditButton from "../buttons/EditButton";
import DeleteButton from "../buttons/DeleteButton";

import styled from "styled-components";
import {useDispatch, useSelector} from "react-redux";
import {loadOneStake} from "./actions/stakeAction";
import {DisplayForAmbassador} from "../../permissions/DisplayAccordingToRole";

const StakeCard = ({
                       name,
                       setOpenDeleteModal,
                       setOpenEditModal,
                       toggle,
                       stakeId,
                       displayProjects,
                   }) => {

    const dispatch = useDispatch()
    const {sponsor} = useSelector(state => state.oneAxis)
    const currentUser = useSelector(state => state.currentUser)

    const updateStake = async (stake_id) => {
        if (stake_id !== 0) {
            await dispatch(loadOneStake(stake_id))
            setOpenEditModal(true)
        }
    }
    return (
        <Card
            onClick={(e) => displayProjects(e)}
            className={`toggle-card ${toggle ? "selected-grey" : ""}`}>
            <h2 className={"toggle-card"}> {name} </h2>
            <ContainerButtons>
                <DisplayForAmbassador
                    hasException={sponsor !== null && sponsor.id === currentUser.id}
                    component={
                        <EditButton
                            tooltipDirection={'top'}
                            setUpdate={updateStake}
                            data={stakeId}
                        />}
                />
                <DisplayForAmbassador
                    hasException={sponsor !== null && sponsor.id === currentUser.id}
                    component={
                        <DeleteButton
                            tooltipDirection={'top'}
                            setOpenDeleteModal={setOpenDeleteModal}
                        />
                    }
                />
            </ContainerButtons>
        </Card>
    )
}

const Card = styled.div`
  border: 1px solid rgb(221, 221, 221);
  border-radius: 12px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  min-height: 50px;
  box-shadow: rgba(0, 0, 0, 0.12) 0 6px 16px;
  cursor: pointer;
  padding: 0 0.5em;
  background-color: var(--color-white);
  &:hover {
    background-color: var(--color-grey-06);
  }

  @media (min-width: 900px) {
    padding: 0 1em;
  }
`
const ContainerButtons = styled.div`
  display: flex;
  flex-direction: row;
  padding-right: 0.5rem;
`

export default StakeCard;